import _ from "lodash";
import axios from "axios";
import { sisi_api_url } from "../api";

var website_api_key = import.meta.env.VITE_APP_WEBSITE_KEY;

export const searchRequestCarRental = async ({ params, onError }) => {
  try {
    const response = await axios.get(`${sisi_api_url}/carrentengine/search`, {
      params: {
        ...params,
        website_api_key,
      },
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
    onError();
  }
  return null;
};

export const searchRequestCarRentalPOST = async ({ payload, onError }) => {
  try {
    const response = await axios.post(`${sisi_api_url}/carrentengine/search`, {
      ...payload,
      website_api_key,
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
    onError();
  }
  return null;
};

export const fetchSavedCarRentalSearchResults = async ({ search_session_id, onError }) => {
  try {
    const response = await axios.get(`${sisi_api_url}/carrentengine/search/${search_session_id}`);
    return response.data;
  } catch {
    onError();
    return null;
  }
};

export const carRentalPreBook = async (payload) => {
  try {
    const response = await axios.post(`${sisi_api_url}/carrentengine/pre-book/`, {
      ...payload,
      website_api_key,
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const carRentalBook = async (payload) => {
  try {
    const response = await axios.post(`${sisi_api_url}/carrentengine/book/`, {
      ...payload,
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};
